import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, allowedRoles }) {
    const { user } = useAuth();

    if (!user) return <Navigate to="/" />;

    // Comprobar si el ID del usuario está en la lista de IDs permitidos
    const userId = user.uid || ''; // Si user.uid es nulo, asigna una cadena vacía
    if (allowedRoles && !allowedRoles.includes(userId)) {
        return <Navigate to="/dashboard" />;
    }

    return <>{children}</>;
}
